<template>
	<div class="recht-block recht-richtext-block" :class="styleClass">
		<div class="recht-block-base" :class="rootClasses">
			<div class="container">
                <div v-if="data.text && data.text.length" v-html="data.text" class="recht-richtext"></div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'Richtext',
	props: {
		data: {
			type: Object,
			default: () => {},
		}
	},
	components: {},
	computed: {
        styleClass() {
            return {}
        },
        rootClasses() {
            return {}
        }
    }
}
</script>

<style lang="scss" scoped>
	
</style>
